import { AutoActionType } from "./constants/autoActions";

const defaultDelaysDays = {
  [AutoActionType.RETARD_LOYER]: 10,
  [AutoActionType.AVIS_ECHEANCE]: 8,
};

export function getFormattedCommentaires(action, tenantAutoAction) {
  return action.commentaires.replace(
    /\[delai]/g,
    tenantAutoAction?.meta?.delai ?? defaultDelaysDays[action.static_id],
  );
}
